export const LOG_TAG = '[@mc/react-app-v4]';

export const DEFAULT_RENDER_ELEMENT_ID = 'root';
// export const DEFAULT_THEME_NS = 'ui-v3';
